import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { IUser } from '../interfaces/iuser';
import { catchError, tap, map } from 'rxjs/operators';
import { LoginDetail } from '../login-detail';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { User } from '../model/user';
import { IPasswordReset } from '../interfaces/ipassword-reset';
//import { tokenGettenFn } from '../app.module';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  //private BASE_URL : string = "https://eservices.lra.gov.lr/tccApp/api/auth";
  private BASE_URL:string = window["cfgApiBaseUrl"];
  private AUTH_URL:string = this.BASE_URL+"auth";
  //private BASE_URL ="http://10.0.16.73:8093/tccApp/api/auth";
  //private BASE_URL ="http://localhost:8081/tccApp/api/auth";
  loggedInStatus = false;
  private user: User;
 
  constructor(private http : HttpClient, private jwtHelper: JwtHelperService, private router: Router) {

   }

 public setLogginStatus(value : boolean){
    this.loggedInStatus = value;
  }

  public get isLoggedIn(){
     return this.loggedInStatus;
  }
  
  public login(ld:LoginDetail){
    return this.http.post(this.AUTH_URL, ld, {responseType: 'text'})
                    .subscribe(tokenResult=>{
                      localStorage.setItem('token', tokenResult);
                       this.router.navigate(['/admin']);
                    });

  }

  public login1(ld:LoginDetail){
    return this.http.post(this.AUTH_URL, ld, {responseType: 'text'}). pipe(map(r =>{
      localStorage.setItem('token', r);
    }))          
  }

  public changePassword(pass:IPasswordReset){
    return this.http.put<any>(this.AUTH_URL, pass);
  }

  errorHandler(error : HttpErrorResponse){
    console.log(error);
    return observableThrowError(error.message || "Server Error");
  }

 public loggedOut(){
    localStorage.clear();
    this.router.navigate(['/login']);
  }
   
  public getCurrentUser(){
  const token = this.jwtHelper.tokenGetter();
  const decodedToken = this.jwtHelper.decodeToken(token);
  //console.log(decodedToken);
  return decodedToken;
  }

  public getCurrentUserTest():Observable<any>{
    const token = this.jwtHelper.tokenGetter();
    const decodedToken = this.jwtHelper.decodeToken(token);
    //console.log(decodedToken);
    const user$ = new Observable(observer=>{
      if(decodedToken.sub !==null){
        observer.next(decodedToken);

      }
      
    })
    return user$;    
  }

public get authenticated(): boolean{
  const token = this.jwtHelper.tokenGetter();
  if(token){
    this.setLogginStatus(true);
    //Check if saved token has not expired
    return !this.jwtHelper.isTokenExpired(token);
  }
  return false
}

}
